// 步骤
// import {addstamp} from '../../util/stamp';
// var params = {
//     user_id: 615
// }
// 接在定义params后
// var sign = addstamp(params)
// delete params.token
// params['sign'] = sign
// console.log(params)

// if(res.data.status_code == 402){
//     that.$router.push('/login')
//   }

// import hmacSHA1 from 'crypto-js/hmac-sha1'
import store from '../store/store'
import md5 from 'js-md5';
export function addstamp(params) {

    var nowdata = Date.parse(new Date()) / 1000
    var newpar = params
    newpar['timestamp'] = nowdata;
    newpar['token'] = '&k2Fwd72zg3$Qhqw@RH%A3auPNi^*nYj';
    // newpar['ip'] = store.state.ip;
    // console.log(store.state.access_token)
    newpar['access_token'] = store.state.access_token;
    newpar = objKeySort(newpar);
    var keys = Object.keys(newpar);
    var value = "";
    for (var i = 0; i < keys.length; i++) {
        var _key = keys[i]
        if (value) {
            value += "&"
        }
        value += _key + '=' + newpar[_key];
    }
    // console.log(value)
    // console.log(newpar)
    var sign = md5(value)
    // delete newpar.token
    // console.log(sign)
    // var sign = hmacSHA1(value, secretkey).toString();
    // newpar['sign'] = sign;
    // console.log(newpar)
//	var newvaule = value
//	newvaule += '&signature='+sign
//  console.log(newvaule)
    return sign
};

export function objKeySort(obj) { //排序的函数
    var newkey = Object.keys(obj).sort();	//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) { //遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; //返回排好序的新对象
};


// WEBPACK FOOTER //
// ./src/util/stamp.js